import { render } from "./itemDetailRouteNavigator.vue?vue&type=template&id=024fe94c&ts=true"
import script from "./itemDetailRouteNavigator.vue?vue&type=script&lang=ts"
export * from "./itemDetailRouteNavigator.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__